import axios from "axios";
import { domain } from "./consts";
import iziToast from "izitoast";

axios.defaults.baseURL = domain.prod;
axios.defaults.headers.common["appId"] = "02";
axios.defaults.headers.common["platform"] = "web";
axios.interceptors.request.use(
  function(config) {
    config.headers.common["lcid"] = sessionStorage.getItem("lcid") || "1028";
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  function(response) {
    if (response.status == 200) {
      return response.data;
    } else {
      iziToast.error({
        title: "error",
        message: response.errMsg,
        close: false,
        drag: false,
      });
      return Promise.reject(response);
    }
  },
  function(error) {
    iziToast.error({
      title: "error",
      message: error.message,
      close: false,
      drag: false,
    });
    return Promise.reject(error);
  }
);

const get = (url, params) => axios.get(url, { params });

const post = (url, body) => axios.post(url, body);

const postParams = (url, params, body) => axios.post(url, body, { params });

export { get, post, postParams };
